var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPersonnelCaptionWhite(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 81,
    height: 80,
    viewBox: "0 0 81 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2367_86514)"
  }, /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M43.501 47.9575H37.4961V63.3035H43.501V47.9575Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M48.1702 52.6279H32.8242V58.6329H48.1702V52.6279Z",
    fill: "#F2F3EE"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M40.409 39.5435C27.1822 39.5435 16.4337 49.9222 16.5398 62.6403C16.5415 62.6418 16.5425 62.6429 16.5441 62.6445H18.8865H22.5387H29.0734V56.6395H23.6231C26.1351 50.1735 32.7117 45.5483 40.409 45.5483C48.1064 45.5483 54.683 50.1735 57.195 56.6395H51.7589V62.6445H58.2795H62.8462H64.2741C64.2757 62.6429 64.2767 62.6418 64.2783 62.6403C64.3844 49.9222 53.6359 39.5435 40.409 39.5435Z",
    fill: "#F2F3EE"
  }), /*#__PURE__*/React.createElement("g", {
    opacity: 0.75
  }, /*#__PURE__*/React.createElement("path", {
    d: "M40.6027 45.5492C32.4518 45.5492 25.8203 39.1748 25.8203 31.3395C25.8203 23.5044 32.4518 17.1299 40.6027 17.1299C48.7536 17.1299 55.3851 23.5043 55.3851 31.3395C55.3851 39.1748 48.7536 45.5492 40.6027 45.5492ZM40.6027 23.1349C35.7628 23.1349 31.8253 26.8154 31.8253 31.3396C31.8253 35.8638 35.7628 39.5442 40.6027 39.5442C45.4426 39.5442 49.3801 35.8638 49.3801 31.3396C49.3801 26.8154 45.4426 23.1349 40.6027 23.1349Z",
    fill: "#F2F3EE"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2367_86514"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 47.74,
    height: 46.1738,
    fill: "white",
    transform: "translate(16.5391 17.1299)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPersonnelCaptionWhite);
export default __webpack_public_path__ + "static/media/personnel-caption-white.f790bc4d93bdf8a2be2da549f396ca87.svg";
export { ForwardRef as ReactComponent };